import { ErrorHandler, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { FullscreenOverlayContainer, OverlayContainer, OverlayModule } from '@angular/cdk/overlay';
import { MatButtonModule } from '@angular/material/button';

import { ErrorComponent } from 'src/app/core/error/error.component';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';

@NgModule({
    imports: [CommonModule, OverlayModule, A11yModule, MatButtonModule, ErrorComponent]
})
export class ErrorHandlerModule {
  public static forRoot(): ModuleWithProviders<ErrorHandlerModule> {
    return {
      ngModule: ErrorHandlerModule,
      providers: [
        { provide: ErrorHandler, useClass: ErrorHandlerService },
        { provide: OverlayContainer, useClass: FullscreenOverlayContainer },
      ]
    };
  }
}
